import React, { useState } from "react";

import { Form, Button, Modal, FloatingLabel, Alert, Spinner} from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../CSS/Signup.css";
import { AuthService } from '../Services/AuthService';
// import { ApiService } from '../Services/APIService';
import { StorageUtils } from '../Utils/StorageUtils'; // Import the utility
import { useNavigate } from "react-router-dom";
import choosePhotoImage from '../assets/choose_photo.png';
const SignupScreen = ({ show, handleClose, onLoginClicked}) => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [apiResponse, setApiResponse] = useState(null);
  const [loading, setLoading] = useState(false); // Loader state
  const [errors, setErrors] = useState({});
const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    image: null,
  });
  

   const resetForm = () => {
    setFormData({
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      confirmPassword: '',
      image: null,
    });
    setErrors({});
    setApiResponse(null);
    setSelectedImage(null);
  };


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setSelectedImage(reader.result); // Preview the selected image
      };
      reader.readAsDataURL(file);
    }
    //setFormData({ ...formData, image: e.target.files[0] });
    formData.image = e.target.files[0]; // Store the file object in formData
    console.log("Image selected:", e.target.files[0]);
    console.log("Form data updated:", formData.image);
  };

  const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);
  const toggleConfirmPasswordVisibility = () => setConfirmPasswordVisible(!confirmPasswordVisible);
  //choose_photo.png

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  
  

  // Validate form
    const validateForm = () => {
    const newErrors = {};
    // if (!formData.firstName.trim()) newErrors.firstName = "First name is required";
    // if (!formData.lastName.trim()) newErrors.lastName = "Last name is required";
    if (!formData.email) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Invalid email address";
    if (!formData.password) newErrors.password = "Password is required";
    else if (formData.password.length < 6) newErrors.password = "Password must be at least 6 characters";
    if (!formData.confirmPassword) newErrors.confirmPassword = "Confirm password is required";
    else if (formData.confirmPassword !== formData.password) newErrors.confirmPassword = "Passwords do not match";
    // if (!formData.image) newErrors.image = "Image is required";
    return newErrors;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length === 0) {
      try {
        setLoading(true); // Start loader
        const name = formData.firstName + " " + formData.lastName;
        const email = formData.email;
        const password = formData.password;
        const selectedImageFile = formData.image; // This should be the File object
        const userData = {
    name,
    email,
    password,
    image: selectedImageFile, // This should be the File object
  };
        //const form = new FormData();
      //form.append('name', formData.firstName + " " + formData.lastName);
      //form.append('email', formData.email);
      //form.append('password', formData.password);
      //if (formData.image) {
//        form.append('profile_image', formData.image); // <-- this must match your backend field name
  //    }
      console.log("Form data to be sent:", userData);
      
        const response = await AuthService.signup(userData);
        console.log("Signup response:", response);
        setApiResponse(response.data);
        // Use comprehensive save that clears cache
        StorageUtils.saveUserDataAndRefresh(response.data);
        console.log('🎆 Signup successful - user data saved with fresh cache:', response.data);
        setTimeout(() => {
          resetForm();
        //handleClose();
         window.dispatchEvent(new Event('storage'));
          // navigate('/');
           navigate('/dashboard');
      }, 2000);
        
      } catch (error) {
        setApiResponse({ error: error.response?.data?.message || 'Signup failed' });
      }
      finally {
        setLoading(false); // Stop loader
      }
      // No validation errors, proceed with form submission
      console.log("Form submitted successfully!", formData);
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <Modal show={show}  onHide={() => {resetForm();handleClose();}} centered>
      <Modal.Header closeButton className="border-0"></Modal.Header>
      <Modal.Body>
        <h2 className="custom-heading-signup"> Get Started Now </h2>
        <Form onSubmit={handleSubmit}>
          {/* Image Picker */}
          <Form.Group  className="mb-3 text-center">
            {selectedImage ? (
              <img
                src={selectedImage}
                alt="usr_image"
                className="mb-3 rounded-circle"
                style={{ width: "100px", height: "100px", objectFit: "cover" }}
                onClick={() => document.getElementById("imagePicker").click()}
              />
            ) : (
              <img
                src={choosePhotoImage}
                alt="usr_image"
                className="mb-3 rounded-circle"
                style={{ width: "100px", height: "100px", objectFit: "cover" }}
                onClick={() => document.getElementById("imagePicker").click()}
              />
            )}
            
            <h3 className="choose-photo-label-signup">Choose Photo</h3>
            <Form.Control
              type="file"
              id="imagePicker"
              className="d-none"
              name="image"
              accept="image/png, image/jpeg"
              onChange={handleImageChange}
              isInvalid={!!errors.image}
            />
            <Form.Control.Feedback type="invalid"> {errors.image}</Form.Control.Feedback>
          </Form.Group>

          {/* First Name */}

          <Form.Group
            className="floating-label-custom mb-3"
          >
            <FloatingLabel label="First Name">
              <Form.Control type="text" name="firstName" placeholder="Enter your first name" value={formData.firstName} onChange={handleInputChange} isInvalid={!!errors.firstName}/>
              <Form.Control.Feedback type="invalid">{errors.firstName}</Form.Control.Feedback>
            </FloatingLabel>
          </Form.Group>

          {/* Last Name */}

          <Form.Group
            className="floating-label-custom mb-3"
          >
            <FloatingLabel label="Last Name">
              <Form.Control type="text" name = "lastName" placeholder="Enter your last name" value={formData.lastName} onChange={handleInputChange} isInvalid={!!errors.lastName}/>
              <Form.Control.Feedback type="invalid">{errors.lastName}</Form.Control.Feedback>
            </FloatingLabel>
          </Form.Group>

          {/* Email */}
                    <Form.Group
            className="floating-label-custom mb-3"
          >
            <FloatingLabel label="Email Address">
              <Form.Control type="email" name="email" placeholder="Enter your email" value={formData.email} onChange={handleInputChange} isInvalid={!!errors.email} />
              <Form.Control.Feedback type="invalid"> {errors.email} </Form.Control.Feedback>
            </FloatingLabel>
          </Form.Group>

          {/* Password */}
          <Form.Group className="floating-label-custom mb-3">
                       <FloatingLabel label="Password" >
                      <Form.Control
                        type={passwordVisible ? "text" : "password"}
                        placeholder="Enter your password"
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        isInvalid={!!errors.password}
                      />
                      <Form.Control.Feedback type="invalid"> {errors.password} </Form.Control.Feedback>
                      <Button
                        variant="outline-secondary"
                        onClick={togglePasswordVisibility}
                        className="toggle-password-visibility"
                      >
                        {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                      </Button>
                    
                  </FloatingLabel>
                    </Form.Group>

          {/* Confirm Password */}

                    <Form.Group  className="floating-label-custom mb-3">
                       <FloatingLabel label="Confirm Password" >
                      <Form.Control
                        type={confirmPasswordVisible ? "text" : "password"}
                        placeholder="Enter your password"
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleInputChange}
                        isInvalid={!!errors.confirmPassword}
                      />
                      <Form.Control.Feedback type="invalid"> {errors.confirmPassword} </Form.Control.Feedback>
                      <Button
                        variant="outline-secondary"
                        onClick={toggleConfirmPasswordVisibility}
                        className="toggle-password-visibility"
                      >
                        {confirmPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                      </Button>
                    
                  </FloatingLabel>
                    </Form.Group>

          {/* Submit Button */}
          <Button variant="success" type="submit" className="custom-login-button-login w-100" disabled={loading}>
            {loading ? (
          <>
            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
            {' Please Wait...'}
          </>
        ) : (
          'Sign Up'
        )}
          </Button>
          {/* API Response */}
      {apiResponse && (
        <Alert variant={apiResponse.error ? 'danger' : 'success'} className="mt-3">
          {apiResponse.error || 'Signup successful!'}
        </Alert>
      )}
        </Form>
        <p className="custom-anchor">
                Already have an account{" "}
                <a href="#" className="custom-anchor-login text-decoration-underline" onClick={onLoginClicked}>
                  Sign In 
                </a>{" "}
                
              </p>
      </Modal.Body>
    </Modal>
  );
};
export default SignupScreen;
